import script from "./TransactionDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransactionDetails.vue?vue&type=script&setup=true&lang=ts"

import "./TransactionDetails.vue?vue&type=style&index=0&id=4b0a9ff6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b0a9ff6"]])

export default __exports__